import * as React from "react";
import { forwardRef } from "react";
const SvgPluginLogo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, rx: 1, fill: "#3E3E3E", style: {
  fill: "#3E3E3E",
  fill: "color(display-p3 0.2431 0.2431 0.2431)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 3.75, y: 3.75, width: 3.5, height: 1.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 3.75, y: 6, width: 3.5, height: 2, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 3.75, y: 8.75, width: 3.5, height: 3.5, rx: 0.375, fill: "#FF6039", style: {
  fill: "#FF6039",
  fill: "color(display-p3 1.0000 0.3776 0.2220)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 3.75, y: 8.75, width: 3.5, height: 3.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 8, y: 3.75, width: 2, height: 1.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 8, y: 6, width: 2, height: 2, rx: 0.375, fill: "#FFA412", style: {
  fill: "#FFA412",
  fill: "color(display-p3 1.0000 0.6435 0.0701)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 8, y: 6, width: 2, height: 2, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 8, y: 8.75, width: 2, height: 3.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 10.75, y: 3.75, width: 1.5, height: 1.5, rx: 0.375, fill: "#2E8CFF", style: {
  fill: "#2E8CFF",
  fill: "color(display-p3 0.1800 0.5490 1.0000)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 10.75, y: 3.75, width: 1.5, height: 1.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 10.75, y: 6, width: 1.5, height: 2, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 10.75, y: 8.75, width: 1.5, height: 3.5, rx: 0.375, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
const ForwardRef = forwardRef(SvgPluginLogo);
export default ForwardRef;
